// Flatten the nested node tree into an ordered list with depth info.
export function flatten(tree, depth = 0, out = []) {
  for (const node of tree) {
    out.push({ ...node, depth });
    if (node.children && node.children.length) {
      flatten(node.children, depth + 1, out);
    }
  }
  return out;
}

export function allDocuments(tree) {
  return flatten(tree).filter((n) => n.type === "document");
}

export function countDocuments(tree) {
  return allDocuments(tree).length;
}
